import { marked } from "marked";

marked.setOptions({ gfm: true, breaks: false });

export function renderMarkdown(input: string | undefined): string {
  if (!input) return "";
  try {
    const result = marked.parse(input, { async: false });
    return typeof result === "string" ? result : "";
  } catch (err) {
    console.warn("[arch-parser] markdown render failed:", err);
    return input;
  }
}
